import { IndexedDBService } from "../../../services/indexed-db-service";

export const userDBService = new IndexedDBService("Auth", "user");
